import { createSlice } from 'redux-starter-kit';

export const defaultAnimationState = {
    animation: null,
};

// REDUCERS
// basic actions that affect this object only

const setAnimationReducer = (state, action) => {
    return {
        animation: action.payload.animation,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultAnimationState,
    };
};

export const animationSlice = createSlice({
    name: 'animation',
    initialState: defaultAnimationState,
    reducers: {
        setAnimation: setAnimationReducer,
        reset: resetReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary

// actions that get exported to the views
export const animationActions = dispatch => {
    return {
        setAnimation: payload =>
            dispatch(animationSlice.actions.setAnimation(payload)),
        reset: payload => dispatch(animationSlice.actions.reset(payload)),
    };
};
